import { render, staticRenderFns } from "./AddCoachPage.vue?vue&type=template&id=2b59c1cf&"
import script from "./AddCoachPage.vue?vue&type=script&lang=js&"
export * from "./AddCoachPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports